module.exports = __webpack_public_path__ + "img/网站3-42.8c25491c.png";